import * as React from "react";

export const NoPermit = () => (
    <div className="split">
        <div className="item">
            <div className="value" xd-qa-type="label" xd-qa-name="No Permit">
                You do not have a permit on file.
            </div>
            <a 
                className="link"
                target="_blank"
                href={"https://pe.usps.com/businessmail101?ViewName=PermitApplication"}
                xd-qa-type="link"
                xd-qa-name="How to Apply for a Permit"
            >
                How to Apply for a Permit?
            </a>
        </div>
        <div className="item">
            <div className="label" xd-qa-type="label" xd-qa-name="Sample">Sample</div>
            <div className="sample">
                <span className="value" xd-qa-type="label" xd-qa-name="FIRST-CLASS MAIL">FIRST-CLASS MAIL</span>
                <span className="value" xd-qa-type="label" xd-qa-name="U.S. POSTAGE">U.S. POSTAGE</span>
                <span className="value" xd-qa-type="label" xd-qa-name="PAID">PAID</span>
                <span className="value" xd-qa-type="label" xd-qa-name="FORT WORTH, TX">FORT WORTH, TX</span>
                <span className="value" xd-qa-type="label" xd-qa-name="PERMIT NO. 123">PERMIT NO. 123</span>
            </div>
        </div>
    </div>
);